import React from 'react';
import { Select } from 'antd';
import _ from 'lodash';

type Props = {
  value: boolean | null,
  onChange: (value: boolean) => void,
  onBlur: () => void,
};

export default function BooleanInput(props: Props) {
  const { value, onBlur, onChange, placeholder } = props;
  return (
    <Select
      placeholder={placeholder}
      style={{ width: '100%' }}
      value={_.isBoolean(value) ? value.toString() : ''}
      onBlur={onBlur}
      onChange={newValue => {
        if (newValue === '') {
          onChange(null);
        } else {
          onChange(newValue === 'true');
        }
      }}
    >
      <Select.Option value="">No Default Value</Select.Option>
      <Select.Option value="true">TRUE</Select.Option>
      <Select.Option value="false">FALSE</Select.Option>
    </Select>
  );
}
